"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CREDIT_PULL = void 0;
var FROZEN = {
    BODY: 'We can’t display your credit score because your credit is frozen',
    MODAL_TITLE: 'Your credit is frozen',
    MODAL_BODY_ONE: 'We aren’t able to access your credit score when your TransUnion credit profile is frozen. If you’d like Flex to display your credit score, you can ',
    MODAL_BODY_LINK: 'log in to TransUnion',
    MODAL_BODY_TWO: ' and remove the freeze.'
};
var INSUFFICIENT_HISTORY = {
    BODY: 'We can’t display your credit score because you don’t have enough credit history',
    MODAL_TITLE: 'You don’t have enough credit history yet',
    MODAL_BODY: 'If you’ve never opened a credit line before or don’t have any that are active, TransUnion may not have enough information to calculate your credit score.\n\nDon’t worry! Keep paying your rent with Flex to build your credit history. After maintaining an active credit line for 6 months, you’ll get a credit score.'
};
var NO_UPDATE = {
    BODY: 'We couldn’t update your credit score last month',
    MODAL_TITLE: 'We couldn’t update your credit score',
    MODAL_BODY_ONE: 'We can’t always update your credit score if we have trouble connecting to TransUnion, can’t identify your credit report. We’ll try again next time.\n\nIf this problem keeps happening, get in touch with ',
    MODAL_BODY_LINK: 'Customer Support',
    MODAL_BODY_TWO: '.'
};
var NO_MATCH = {
    BODY: 'We can’t find a credit profile that matches your information',
    MODAL_TITLE: 'We couldn’t find your credit profile',
    MODAL_BODY_ONE: 'If the information you provided to Flex when you signed up doesn’t match your credit profile with TransUnion, we won’t be able to show your credit score.\n\nGet in touch with ',
    MODAL_BODY_LINK: 'Customer Support',
    MODAL_BODY_TWO: ' to help us find your credit profile.'
};
exports.CREDIT_BUILDER_CREDIT_PULL = {
    CTA: 'Close',
    FROZEN: FROZEN,
    INSUFFICIENT_HISTORY: INSUFFICIENT_HISTORY,
    NO_UPDATE: NO_UPDATE,
    NO_MATCH: NO_MATCH
};
